<template>
    <Teleport to="body">
        <div v-if="modelValue" class="modal-overlay" @click.self="close">
            <div class="modal-content">
                <slot></slot>
            </div>
        </div>
    </Teleport>
</template>

<script setup>

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
})
const emits = defineEmits(['update:modelValue'])

function close() {
    emits('update:modelValue', false)
}
</script>

<style scoped lang="scss">
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100dvw;
    height: 100dvh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: end;
    z-index: 9999;
}

.modal-content {
    background: #fff;
    padding: 1rem 2rem;
    border-radius: 25px 25px 0 0;
    width: 100dvw;
    overflow-y: auto;

    // Responsive max-height using dvh
    max-height: 90dvh;

    // On small screens (e.g. landscape phones), cap lower so content stays accessible
    @media (max-height: 500px) {
        max-height: 80dvh;
        padding: 0.75rem 1.25rem;
    }

    // On tablets and up, constrain width and center the modal
    @media (min-width: 768px) {
        width: 60dvw;
        max-height: 85dvh;
        border-radius: 25px;
        margin-bottom: 2dvh;
    }

    // On large desktops, keep it from getting too wide
    @media (min-width: 1200px) {
        width: 40dvw;
        max-height: 80dvh;
    }
}

.close {
    position: absolute;
    top: 0;
    right: 0;
    margin: 10px;
    padding: 0;
    background-color: transparent;
    border: none;
    justify-content: center;
    align-items: center;
    align-self: center;
    cursor: pointer;

    i {
        font-size: 40px;
    }

    &:hover {
        color: $orange;
    }
}
</style>